export default class Bridge {
	static checkAuthentication() {
		return document.querySelector("meta[name='turbo:authenticated']").content
	}
}
